/**
 * API Configuration
 * Centralized API URL management with production HTTPS enforcement
 */

import { logAPI } from '../utils/logger';

/**
 * Gets the API base URL with production HTTPS enforcement
 * @returns The validated API base URL
 * @throws Error if production environment uses HTTP or if API URL is not configured
 */
export const getApiBaseUrl = (): string => {
  let url: string;

  if (process.env.REACT_APP_API_BASE_URL) {
    url = process.env.REACT_APP_API_BASE_URL;
  } else if (process.env.NODE_ENV === 'development') {
    // Only use localhost in development
    url = 'http://localhost:5119/api';
  } else {
    const error = 'REACT_APP_API_BASE_URL is required in production builds';
    logAPI.error(error);
    throw new Error(error);
  }

  // Remove trailing slash
  url = url.replace(/\/$/, '');

  // Enforce HTTPS in production
  if (process.env.NODE_ENV === 'production' && url.startsWith('http://')) {
    const error = 'HTTPS is required in production. Please set REACT_APP_API_BASE_URL to use HTTPS.';
    logAPI.error(error);
    throw new Error(error);
  }

  return url;
};

/**
 * The API base URL - validated and ready to use
 * In production, this will enforce HTTPS
 */
export const API_BASE_URL = getApiBaseUrl();
